import { HttpClient } from '@/shared/lib/http-client';

export const searchCityByName = async (name) => {
  const response = await HttpClient.get('/directories/cities/find', {
    city: name,
  });

  return response.data?.data;
};
